import React, { PureComponent } from 'react';
import DataBlock from 'components/ui/dataBlock';
import PaymentDataMapper from '../PaymentDataMapper';
import { AnyObject } from 'types/Common';
import PaymentPageUI from 'types/PaymentPageUI';
import RecurringCardPageUI from 'types/RecurringCardPageUI';

interface Props {
  operation: AnyObject;
  transactionId: string;
  pageUI: PaymentPageUI | RecurringCardPageUI | undefined;
  onChangePageUI: (objectState: AnyObject) => void;
}

class OperationInfo extends PureComponent<Props> {
  render() {
    const { operation } = this.props;

    if (!operation) return null;

    const {
      operationInfo,
      cryptoInfo,
      paymentMethodInfo,
      paymentProviderInfo,
      secure,
      address,
      callback,
      deviceInfo,
      fraud,
      vatBillingInfo,
      p2pInfo,
    } = PaymentDataMapper.getOperationInfo(operation);

    return (
      <div className='max-desktop-m:flex-col flex gap-4'>
        <div className='max-desktop-m:w-full w-1/2'>
          <DataBlock
            title='payments.single.operationInfo.header'
            data={operationInfo}
            theme='modern'
          />

          <DataBlock
            title='payments.single.providerInfo.header'
            data={paymentProviderInfo}
            theme='modern'
          />

          <DataBlock
            title='payments.single.deviceInfo.header'
            data={deviceInfo}
            theme='modern'
          />
        </div>

        <div className='max-desktop-m:w-full w-1/2'>
          <DataBlock
            title='payments.data.paymentMethod.header'
            data={paymentMethodInfo}
            theme='modern'
          />

          <DataBlock
            title='payments.single.callback.header'
            data={callback}
            theme='modern'
          />

          <DataBlock
            title='payments.single.3DSecure.header'
            data={secure}
            theme='modern'
          />

          {address.isVisible && (
            <DataBlock
              title='payments.single.address.header'
              data={address.content}
              theme='modern'
            />
          )}

          {fraud.isFraud && (
            <DataBlock
              title={'payments.single.fraud.header'}
              data={fraud.content}
              theme='modern'
            />
          )}

          {cryptoInfo.isVisible && (
            <DataBlock
              title='payments.single.cryptoInfo.header'
              data={cryptoInfo.content}
              theme='modern'
            />
          )}

          {vatBillingInfo.isVisible && (
            <DataBlock
              title='payments.single.BillingInfo.header'
              data={vatBillingInfo.content}
              theme='modern'
            />
          )}

          <DataBlock
              title='payments.single.p2pInfo.header'
              data={p2pInfo.content}
              theme='modern'
          />
        </div>
      </div>
    );
  }
}

export default OperationInfo;
